import ScrollTop from '../../../components/utils/ScrollTop'
import MetaTags from '../../../components/meta/MetaTags'
import Testimonials from '../../../components/landing/Testimonials'
import BaseFAQ from '../../../components/landing/FAQ'
import Header from './Header'
import BecomeHost from './BecomeHost'
import HowItWorks from './HowItWorks'
import OurPurpose from './OurPurpose'
import JoinUs from './JoinUs'
import { faqs, testimonials } from './content'
import { SectionContainer } from './styles'

const OnboardingUsa = () => {
  return (
    <>
      <MetaTags title="Become a Riparide Host" />
      <ScrollTop />

      <Header />

      <SectionContainer>
        <BecomeHost />
      </SectionContainer>

      <SectionContainer>
        <Testimonials testimonials={testimonials} />
      </SectionContainer>

      <SectionContainer>
        <HowItWorks />
      </SectionContainer>

      <SectionContainer>
        <OurPurpose />
      </SectionContainer>

      <SectionContainer>
        <JoinUs />
      </SectionContainer>

      <SectionContainer style={{ marginTop: '0px' }}>
        <BaseFAQ items={faqs} />
      </SectionContainer>
    </>
  )
}

export default OnboardingUsa
